module.exports = __webpack_public_path__ + "static/media/ichiban-bento.9041fc34.png";